import API from "../../api";
import { checkAPIResponse } from "../helpers";

export default class Site {
  /**
   * The Site dimension table for M3
   * @param {String} siteName The full name of the Site
   * @param {String} abbreviation The shorthand abbreviation for the Site
   * @param {String} singleLetterAbv Single letter abbreviation
   * @param {bool} isActive Is active site
   * @param {bool} isExternalSite Is external site
   * @param {String} siteContact
   * @param {String} address
   * @param {String} city
   * @param {String} state
   * @param {String} postalCode
   * @param {String} country
   * @param {String} phoneNumber
   * @param {String} createdByEmail 
   * @param {Datetime} createdDate 
   * @param {String} lastModifiedByEmail 
   * @param {Datetime} lastModifiedDate
   * @param {[]} locations locations belonging to the site
   **/
  constructor({ 
    siteName,
    abbreviation,
    singleLetterAbv,
    isActive,
    isExternalSite,
    siteContact,
    address,
    city,
    state,
    postalCode,
    country,
    phoneNumber,
    createdByEmail,
    createdDate,
    lastModifiedByEmail,
    lastModifiedDate,
    locations }) {
    this.siteName = siteName;
    this.abbreviation = abbreviation;
    this.singleLetterAbv = singleLetterAbv;
    this.isActive = isActive;
    this.isExternalSite = isExternalSite;
    this.siteContact = siteContact;
    this.address = address;
    this.city = city;
    this.state = state;
    this.postalCode = postalCode;
    this.country = country;
    this.phoneNumber = phoneNumber;
    this.createdByEmail = createdByEmail;
    this.createdDate = createdDate;
    this.lastModifiedByEmail = lastModifiedByEmail;
    this.lastModifiedDate = lastModifiedDate;    
    this.locations = locations ?? [];
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/site`);
    return data.result.map((d) => new Site(d));
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/site`);
    if (data && data.result && data.result.length > 0) {
        return data.result.filter((d) => d.isActive);
    }
    else {
        return [];
    }
  }

  static async get(name) {
    const api = await API();
    const {data} = await api.get(`site/${name}`);
    return data.result ?  new Site(data.result) : null;
  }

  static async add(info) {
    const api = await API();
    const response = await api.post(`/site`, info);
    checkAPIResponse(response);
    return new Site(response.data.result);
  }

  static async update(siteName, info) {
    const api = await API();
    const response = await api.put(`/site/${siteName}`, info);
    checkAPIResponse(response);
    return new Site(response.data.result);
  }
}
